"use strict";

var _taggedTemplateLiteral = require("/codebuild/output/src253626114/src/mrt-covid19-center/node_modules/@babel/runtime/helpers/taggedTemplateLiteral");

var _templateObject, _templateObject2, _templateObject3, _templateObject4, _templateObject5;

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.gradientBackground = exports.btn = exports.buttonContainer = exports.contentHidden = exports.content = void 0;

var react_1 = require("@emotion/react");

exports.content = react_1.css(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  display: block;\n  width: 100%;\n  height: auto;\n  padding-bottom: 16px;\n  font-size: 15px;\n  line-height: 24px;\n  letter-spacing: -0.4px;\n  color: var(--gray-800);\n  overflow: hidden;\n"])));

var contentHidden = function contentHidden(limit) {
  return react_1.css(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n  height: ", "px;\n"])), limit);
};

exports.contentHidden = contentHidden;
exports.buttonContainer = react_1.css(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n  margin-bottom: 20px;\n"])));
exports.btn = react_1.css(_templateObject4 || (_templateObject4 = _taggedTemplateLiteral(["\n  margin-top: 8px;\n  line-height: 28px;\n"])));
exports.gradientBackground = react_1.css(_templateObject5 || (_templateObject5 = _taggedTemplateLiteral(["\n  position: relative;\n  z-index: 0;\n\n  &::before {\n    content: '';\n    position: absolute;\n    left: 0;\n    bottom: 0;\n    display: block;\n    width: 100%;\n    height: 100px;\n    background: linear-gradient(\n      360deg,\n      rgba(255, 255, 255, 1) 35.42%,\n      rgba(255, 255, 255, 0) 100%\n    );\n    z-index: -1;\n  }\n"])));